import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { resolveSiteImage, useSiteContent } from '../context/SiteContentContext';
import { useNavigate } from 'react-router-dom';
import { useUiPreferences } from '../context/UiPreferencesContext';
import { useUser } from '../context/UserContext';
import { API_BASE_URL } from '../config/apiConfig';
import './Navbar.css';

const navItems = [
  { href: '#inicio', label: 'Inicio' },
  { href: '#sobre-mi', label: 'Sobre mí' },
  { href: '#servicios', label: 'Servicios' },
  { href: '#recomendaciones', label: 'Recomendaciones' },
  { href: '#testimonios', label: 'Testimonios' },
  { href: '#contacto', label: 'Contacto', cta: true }
];

function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();
  const { images } = useSiteContent();
  const { theme, setTheme, fontSize, setFontSize } = useUiPreferences();
  const { user, login, register, logout } = useUser();
  const [authOpen, setAuthOpen] = useState(false);
  const [mode, setMode] = useState("login");
  const [form, setForm] = useState({ name: "", email: "", password: "", passwordConfirm: "", captchaAnswer: "", website: "" });
  const [captcha, setCaptcha] = useState({ question: "", token: "" });
  const [error, setError] = useState("");
  const submitAuth = async (event) => { event.preventDefault(); setError(""); try { await (mode === "login" ? login(form) : register({ ...form, captchaToken: captcha.token })); setAuthOpen(false); } catch (e) { setError(e.message); } };
  useEffect(() => { if (!authOpen || mode !== "register") return; fetch(API_BASE_URL + "/api/auth/captcha").then(r => r.json()).then(setCaptcha).catch(() => setError("No se pudo cargar la verificación anti-bots.")); }, [authOpen, mode]); 

  const closeMenu = () => setIsOpen(false);
  const goToSection = (event, href) => {
    event.preventDefault();
    const id = href.replace(/^#/, "");
    const scroll = () => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
    if (window.location.hash !== "#/" && window.location.hash !== "") { navigate("/"); window.setTimeout(scroll, 80); } else { scroll(); }
    closeMenu();
  };

  return (
    <header className="site-header">
      <nav className="navbar" aria-label="Principal">
        <a href="#inicio" className="brand" onClick={event => goToSection(event, "#inicio")}>
          <img src={resolveSiteImage(images.logo.src)} alt={images.logo.alt} className="logo" />
          <span className="brand-copy">
            <strong>Vero Echavarria</strong>
            <span>Mentora en maternidad</span>
          </span>
        </a>

        <button
          className={`hamburger ${isOpen ? 'is-open' : ''}`}
          type="button"
          onClick={() => setIsOpen(!isOpen)}
          aria-label="Abrir navegación"
          aria-expanded={isOpen}
        >
          <span className="bar"></span>
          <span className="bar"></span>
          <span className="bar"></span>
        </button>

        <div className={`nav-links ${isOpen ? 'open' : ''}`}>
          {user && <a href="#/blog" className="nav-link" onClick={closeMenu}>Mi blog</a>}
          {navItems.map((item) => (
            <a
              href={item.href}
              className={`nav-link ${item.cta ? 'nav-cta' : ''}`}
              key={item.href}
              onClick={event => goToSection(event, item.href)}
            >
              {item.label}
            </a>
          ))}
        </div>
        <div className="accessibility-tools" aria-label="Preferencias del sitio">
          <button type="button" onClick={() => setFontSize(Math.max(85, fontSize - 10))} aria-label="Achicar letra">A−</button>
          <button type="button" onClick={() => setFontSize(Math.min(125, fontSize + 10))} aria-label="Agrandar letra">A+</button>
          <button type="button" onClick={() => setTheme(theme === "light" ? "dark" : "light")} aria-label="Cambiar tema">{theme === "light" ? "☾" : "☀"}</button>
          {user ? <button type="button" className="user-button" onClick={() => setAuthOpen(true)}>{user.name}</button> : <button type="button" className="user-button" onClick={() => { setMode("login"); setAuthOpen(true); }}>Ingresar</button>}
        </div>
      </nav>
      {authOpen && createPortal(<div className="auth-overlay" role="dialog" aria-modal="true"><section className="auth-card">{user ? <><p className="eyebrow">Mi perfil</p><h2>{user.name}</h2><p>{user.email}</p><button className="button button-primary" onClick={logout}>Cerrar sesión</button></> : <><button className="auth-close" onClick={() => setAuthOpen(false)} aria-label="Cerrar">×</button><p className="eyebrow">Área personal</p><h2>{mode === "login" ? "Ingresar" : "Crear cuenta"}</h2><form className="form-grid" onSubmit={submitAuth}>{mode === "register" && <div className="form-field"><label htmlFor="auth-name">Nombre</label><input id="auth-name" required value={form.name} onChange={e => setForm({...form,name:e.target.value})}/></div>}<div className="form-field"><label htmlFor="auth-email">Email</label><input id="auth-email" type="email" required value={form.email} onChange={e => setForm({...form,email:e.target.value})}/></div><div className="form-field"><label htmlFor="auth-password">Contraseña</label><input id="auth-password" type="password" minLength="8" required value={form.password} onChange={e => setForm({...form,password:e.target.value})}/></div>{mode === "register" && <><div className="form-field"><label htmlFor="auth-password-confirm">Repetir contraseña</label><input id="auth-password-confirm" type="password" minLength="8" required value={form.passwordConfirm} onChange={e => setForm({...form,passwordConfirm:e.target.value})}/></div><div className="form-field"><label htmlFor="auth-captcha">{captcha.question || "Cargando verificación…"}</label><input id="auth-captcha" inputMode="numeric" required value={form.captchaAnswer} onChange={e => setForm({...form,captchaAnswer:e.target.value})}/></div><input className="honeypot" tabIndex="-1" autoComplete="off" aria-hidden="true" value={form.website} onChange={e => setForm({...form,website:e.target.value})}/></>}{error && <p className="form-status error">{error}</p>}<button className="button button-primary" type="submit">{mode === "login" ? "Ingresar" : "Registrarme"}</button></form><button className="text-link" type="button" onClick={() => setMode(mode === "login" ? "register" : "login")}>{mode === "login" ? "Crear una cuenta" : "Ya tengo una cuenta"}</button></>}</section></div>, document.body)}
    </header>
  );
}

export default Navbar;
